import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import Result from './result';
import "./result.css"

function Navbar() {
  const [menuOpen,setMenuOpen]=useState(false)
  const furniture = [
    {
        name: "Stackable Chair",
        price: "$87.00",
        imageUrl: "assets/product-1.png"
    },
    {
        name: "Lamp Tool",
        price: "$35.00",
        imageUrl: "assets/product-2.png"
    },
    {
        name: "Dining Chair",
        price: "$55.00",
        imageUrl: "assets/product-3.png"
    },
    {
        name: "Hand Base Lamp",
        price: "$35.00",
        imageUrl: "assets/product-4.png"
    },
    {
        name: "Stylish Chair",
        price: "$45.00",
        imageUrl: "assets/product-5.png"
    },
    {
        name: "Vintage Chair",
        price: "$65.00",
        imageUrl: "assets/product-6.png"
    }
    ,{
      name: "Vintage stool",
      price: "$65.00",
      imageUrl: "assets/product-7.jpg"
  }
];
    const [isSearch,setIsSearch]=useState(false);
    const [isShonResult,setIsShownResult]=useState(false)
    const [searchInput,setSearchInput]=useState("")

    const seachArray=furniture.filter(object=>object.name.toLowerCase().includes(searchInput))
    const furnitureElements=seachArray.map(object=><div class="search-product__card">
      <h4>{object.name}</h4>
      <p>{object.price}</p>
      <img src={object.imageUrl} alt="product" loading='lazy'/>
  </div>
)
    const handleChange=(event)=>{
      if (event.target.value.length > 0) {
      setIsShownResult(true)

  
      } else {
      setIsShownResult(false)

  
      }
      setSearchInput(event.target.value)
    }
  return (
    <div>
      {isShonResult?   <section class="body">
        <section class="search-result">
            <section class="search-section__container search-product__container" id="search-product">
            <div class="search-product__grid" id="search-product__grid">
              
            <h2 class="search-section__header"> <span className='cancel-icon' onClick={()=>{setIsShownResult(false)}}>X</span>Your Product</h2>
              {furnitureElements}
            </div>
                <h2 class="search-section__header"> Other Products</h2>
                <div class="search-product__grid" id="search-product__grid">
                    <div class="search-product__card">
                        <h4>Stackable Chair</h4>
                        <p>$87.00</p>
                        <img src="assets/product-1.png" alt="product" loading='lazy'/>
                    </div>
                    <div class="search-product__card">
                        <h4>Lamp Tool</h4>
                        <p>$35.00</p>
                        <img src="assets/product-2.png" alt="product" loading='lazy'/>
                    </div>
                    <div class="search-product__card">
                        <h4>Dining Chair</h4>
                        <p>$55.00</p>
                        <img src="assets/product-3.png" alt="product" loading='lazy'/>
                    </div>
                    <div class="search-product__card">
                        <h4>Hand Base Lamp</h4>
                        <p>$35.00</p>
                        <img src="assets/product-4.png" alt="product" loading='lazy'/>
                    </div>
                    <div class="search-product__card">
                        <h4>Stylish Chair</h4>
                        <p>$45.00</p>
                        <img src="assets/product-5.png" alt="product" loading='lazy'/>
                    </div>
                    <div class="search-product__card">
                        <h4>Vintage Chair</h4>
                        <p>$65.00</p>
                        <img src="assets/product-6.png" alt="product" loading='lazy'/>
                    </div>
                </div>
            </section>
        </section>
    </section>:""}


      <nav>
      <div class="nav__header">
        <div class="nav__logo">
          <a href="#" class="logo">IanInteriors</a>
        </div>
        <div class="nav__menu__btn" id="menu-btn" >
          
          
          {menuOpen?<i class="ri-close-line" onClick={()=>{setMenuOpen(false)}}></i>:<i class="ri-menu-line" onClick={()=>{setMenuOpen(true)}}></i>}
        </div>
      </div>
      <ul class={menuOpen?"nav__links open":"nav__links"} id="nav-links ">
      <NavLink to="/" onClick={()=>{setMenuOpen(false)}}>Home</NavLink>
      <li onClick={()=>{setMenuOpen(false)}}><a href="#about">About</a></li>

      <li onClick={()=>{setMenuOpen(false)}}><a href="#product">Products</a></li>


        <NavLink to="/register" onClick={()=>{setMenuOpen(false)}}>My Account</NavLink>
        <NavLink to="/contact" onClick={()=>{setMenuOpen(false)}}>Contact</NavLink>



        
      </ul>
      <div class={isSearch?"nav__search open":"nav__search"} id="nav-search" >
        <input type="text" placeholder="Search" onChange={handleChange}/>
        <span><i class="ri-search-2-line" onClick={()=>{setIsSearch(prevState=>!prevState)}}></i></span>
      </div>
    </nav>
    </div>
  )
}

export default Navbar
